document.addEventListener("DOMContentLoaded", function () {
  handleCustomVariantPickers();
});

function parseCents(value) {
  const cents = Number(value);
  return Number.isFinite(cents) ? cents : 0;
}

function updatePriceText(element, cents) {
  if (!element) return;

  element.textContent =
    "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function handleCustomVariantPickers() {
  const productScopes = new Set(
    Array.from(document.querySelectorAll(".custom-variant-picker"))
      .map((picker) => picker.closest("product-info"))
      .filter(Boolean),
  );

  productScopes.forEach((productInfo) => {
    const picker = productInfo.querySelector(".custom-variant-picker");
    const mainProductPrice = productInfo.querySelector(".product_price");
    const customOptions = productInfo.querySelectorAll(".custom-variant-picker__options input");

    if (!picker || !mainProductPrice || !customOptions.length) return;

    const pricing = createCustomPickerPricing(mainProductPrice, {
      price: parseCents(picker.dataset.productBasePrice),
      compare_at_price: parseCents(picker.dataset.productCompareAtPrice) || null,
    });

    pricing.update(customOptions);
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
      const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
      if (!data?.variant || (sectionId && data.sectionId !== sectionId)) return;

      pricing.setVariant(data.variant);
      syncQuoteVariant(productInfo, data.variant);
      pricing.update(customOptions);
    });
    customOptions.forEach((option) => {
      option.addEventListener("change", () => {
        pricing.update(customOptions);
      });
    });
    mainProductPrice.querySelector(".price")?.classList.remove("hidden");
  });
}

function syncQuoteVariant(productInfo, variant) {
  productInfo.querySelectorAll("[data-product-quote-form]").forEach((form) => {
    const variantInput = form.querySelector('input[name="id"]');
    form.dataset.productVariantId = String(variant.id || "");
    form.dataset.productVariantTitle = variant.title || "";
    form.dataset.productBasePrice = String(parseCents(variant.price));
    if (variantInput) {
      variantInput.value = String(variant.id || "");
      variantInput.dataset.variantSku = variant.sku || "";
    }
  });
}

function getSelectedCustomVariantOptions(scope = document) {
  const root = scope || document;

  return Array.from(root.querySelectorAll('[data-custom-variant-picker]')).flatMap((picker) => Array.from(
    picker.querySelectorAll('.custom-variant-picker__options input[type="radio"], .custom-variant-picker__options input[type="checkbox"]'),
  ))
    .filter((option) => option.checked && !String(option.id || '').includes('none'));
}

window.Express = window.Express || {};
window.Express.customVariantPicker = window.Express.customVariantPicker || {};
window.Express.customVariantPicker.getSelectedOptions = getSelectedCustomVariantOptions;

function createCustomPickerPricing(mainProductPrice, initialVariant) {
  let variant = initialVariant;

  return {
    setVariant(nextVariant) {
      variant = nextVariant;
    },
    update(options) {
      const priceRoot = mainProductPrice.querySelector(".price");
      if (!priceRoot) return;

      const isOnSale = parseCents(variant.compare_at_price) > parseCents(variant.price);
      const priceSpan = isOnSale
        ? priceRoot.querySelector(".price__sale .price-item.price-item--sale")
        : priceRoot.querySelector(".price__regular .price-item.price-item--regular");
      const compareAtPriceSpan = isOnSale
        ? priceRoot.querySelector(".price__sale .price-item.price-item--regular")
        : null;
      const extraPriceCents = Array.from(options)
        .filter((option) => option.checked)
        .reduce((total, option) => total + parseCents(option.dataset.price), 0);

      updatePriceText(priceSpan, parseCents(variant.price) + extraPriceCents);
      updatePriceText(compareAtPriceSpan, parseCents(variant.compare_at_price) + extraPriceCents);
    },
  };
}
